import gmailConnector from "./gmail-connector.json";

export default {
  gmailConnector,
};
